module.exports = __webpack_public_path__ + "static/media/operador-logo-amil.f398e228.svg";